import React from "react";
import { redirect, Navigate} from "react-router-dom";

const NotFound = () => {
  return <Navigate to="/" replace />;

};

export default NotFound;
